<template>
    <v-container class="pt-10 pb-16 page-privacy">
      <v-row justify="center">
        <v-col cols="12" md="10">
          <!-- PAGE TITLE -->
          <h1 class="page-title mb-4">
            TERMS AND CONDITIONS OF SERVICE (USA)
          </h1>
  
          <p class="mb-1"><strong>Operating Entity:</strong> OH YES LLC</p>
          <p class="mb-6"><strong>Last Updated:</strong> January 21, 2026</p>
  
          <!-- 1 -->
          <section>
            <h3>1. THE PLATFORM AS AN AGGREGATOR</h3>
            <p>
              The "OhYes" mobile application and website (collectively, the
              "Platform") are owned and operated by OH YES LLC, a limited liability
              company incorporated in the United States.
            </p>
            <ul>
              <li>
                <strong>Platform Role:</strong>
                OH YES LLC acts solely as a digital marketplace (aggregator) that
                connects Users ("Customer") with independent third-party service
                providers ("Service Partners").
              </li>
              <li>
                <strong>No Employment:</strong>
                Service Partners are independent contractors and are not
                employees, agents, or joint venturers of OH YES LLC.
              </li>
              <li>
                <strong>Direct Contract:</strong>
                When a Customer books a service, the legal contract for the
                performance of that work is formed directly between the Customer
                and the Service Partner. OH YES LLC is not a party to that
                contract.
              </li>
            </ul>
          </section>
  
          <!-- 2 -->
          <section>
            <h3>2. PRICING, ESTIMATES, AND ON-SITE QUOTES</h3>
            <ul>
              <li>
                <strong>Informational Estimates:</strong>
                Any prices displayed on the Platform (e.g., "$100" or "$150") are
                preliminary averages based on standard industry data. These are
                not fixed quotes and are subject to change.
              </li>
              <li>
                <strong>Mandatory On-Site Inspection:</strong>
                Because every job site is unique, the final price can only be
                determined after the Service Partner arrives at the Customer's
                location and performs a physical inspection.
              </li>
              <li>
                <strong>Customer Confirmation:</strong>
                The Service Partner will provide a final quote based on labor,
                time, materials, and complexity. Work shall not commence until
                the Customer explicitly confirms and agrees to this final price.
              </li>
              <li>
                <strong>Right to Decline:</strong>
                If the Customer rejects the on-site quote, they may cancel the
                service, though a nominal "Trip Fee" or "Diagnostic Fee" may be
                charged to compensate the Service Partner for travel.
              </li>
            </ul>
          </section>
  
          <!-- 3 -->
          <section>
            <h3>3. CUSTOMER OBLIGATIONS & VERIFICATION</h3>
            <p>To ensure safety and quality, the Customer agrees to:</p>
            <ul>
              <li>
                <strong>Verification:</strong>
                Verify the Service Partner’s identity and any state-required
                licenses or certifications upon arrival. While OH YES LLC
                performs basic vetting, the final decision to allow a Partner
                into the home rests with the Customer.
              </li>
              <li>
                <strong>Safe Environment:</strong>
                Provide a safe, hazard-free work area and ensure that an adult
                (18+) is present at all times.
              </li>
              <li>
                <strong>Accurate Descriptions:</strong>
                Provide honest and detailed descriptions of the repair or
                maintenance needs during the booking process.
              </li>
            </ul>
          </section>
  
          <!-- 4 -->
          <section>
            <h3>4. PAYMENTS AND BILLING</h3>
            <ul>
              <li>
                <strong>Payment at Time of Service:</strong>
                Full payment is due immediately upon the completion of the
                service.
              </li>
              <li>
                <strong>Platform Payment Protection:</strong>
                For security and record-keeping, all payments must be processed
                through the Platform’s integrated payment gateway.
              </li>
              <li>
                <strong>Taxes:</strong>
                All service fees are subject to applicable state and local sales
                taxes based on the service location.
              </li>
            </ul>
          </section>
  
          <!-- 5 -->
          <section>
            <h3>5. LIMITATION OF LIABILITY</h3>
            <ul>
              <li>
                <strong>Disclaimer of Work:</strong>
                OH YES LLC makes no representations or warranties regarding the
                quality, reliability, or safety of the services provided by
                Service Partners.
              </li>
              <li>
                <strong>Damages:</strong>
                OH YES LLC shall not be liable for any property damage, personal
                injury, loss of data, or incidental damages arising from the
                Service Partner's work.
              </li>
              <li>
                <strong>Workmanship Disputes:</strong>
                Any claims regarding defective work, warranties, or "re-work"
                must be resolved directly with the Service Partner who performed
                the task.
              </li>
            </ul>
          </section>
  
          <!-- 6 -->
          <section>
            <h3>6. LEGAL & HEALTH COMPLIANCE (PANDEMIC CLAUSE)</h3>
            <ul>
              <li>
                <strong>Local Laws:</strong>
                Both the Customer and the Service Partner agree to comply with
                all federal, state, and municipal laws, including building codes
                and labor regulations.
              </li>
              <li>
                <strong>Health Protocols:</strong>
                During any public health emergency or pandemic, both parties
                must adhere to CDC guidelines and State Department of Health
                mandates (including social distancing and PPE).
              </li>
              <li>
                OH YES LLC reserves the right to suspend accounts of Users or
                Partners who refuse to follow safety protocols.
              </li>
            </ul>
          </section>
  
          <!-- 7 -->
          <section>
            <h3>7. DISPUTE RESOLUTION AND ARBITRATION</h3>
            <ul>
              <li>
                <strong>Mediation:</strong>
                While OH YES LLC is not liable for service issues, we may offer
                mediation services to help resolve disputes between Customers
                and Partners.
              </li>
              <li>
                <strong>Governing Law:</strong>
                These terms are governed by the laws of the State of Illinois,
                without regard to conflict of law principles.
              </li>
              <li>
                <strong>Binding Arbitration:</strong>
                Any dispute between the User and OH YES LLC shall be resolved
                through binding arbitration, rather than in a court of law.
              </li>
            </ul>
          </section>
  
          <!-- 8 -->
          <section>
            <h3>8. TERMINATION OF USE</h3>
            <p>
              OH YES LLC reserves the right to terminate or suspend access to the
              Platform for any User who violates these terms, fails to pay for
              services, or exhibits behavior that is deemed unsafe or
              unprofessional.
            </p>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "TermsAndConditionsUsa",  
  };
  </script>
  
  <style scoped>
  .page-title {
    font-size: 34px;
    font-weight: 700;
  }
  
  section {
    margin-bottom: 28px;
  }
  
  h3 {
    font-size: 16px;
    font-weight: 600;
    margin-top: 18px;
    margin-bottom: 6px;
  }
  
  p,
  li {
    font-size: 15px;
    color: #444;
    line-height: 1.7;
  }
  
  ul {
    padding-left: 20px;
  }
  </style>
  